var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DecimalInput } from '../DecimalInput';
/**
 * @deprecated
 */
var PercentageInput = function (_a) {
    var value = _a.value, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, disabled = _a.disabled, alignText = _a.alignText, placeholder = _a.placeholder, decimalScale = _a.decimalScale, minDecimalScale = _a.minDecimalScale, otherProps = __rest(_a, ["value", "onBlur", "onFocus", "onKeyDown", "disabled", "alignText", "placeholder", "decimalScale", "minDecimalScale"]);
    return (React.createElement(DecimalInput, __assign({ suffix: '%', decimalScale: decimalScale, minDecimalScale: minDecimalScale, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, disabled: disabled, value: value }, otherProps, { alignText: alignText })));
};
PercentageInput.defaultProps = {
    decimalScale: 2,
    placeholder: '0.00',
    minDecimalScale: 2,
    alignText: 'initial',
};
export default PercentageInput;
//# sourceMappingURL=PercentageInput.js.map